<template>
    <div class="timeline_item_dot animated zoomIn">
        <kgr-child-status-icon
            :title="title"
            :spinning="spinning"
            :status="status"
            :disabled="inFuture"
        />
    </div>
</template>

<script>
import ChildStatusIcon from '../../child/contract/ChildStatusIcon';

export default {
    components: {
        'kgr-child-status-icon': ChildStatusIcon,
    },
    props: {
        status: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            required: false,
        },
        spinning: {
            type: Boolean,
            required: false,
            default: false,
        },
        inFuture: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.timeline_item_dot {
    border-radius: 50%;
    z-index: 1;
    background-color: #ffffff;
    margin-left: 11px;
    margin-right: 11px;
}
</style>
